import fetch from "./fetch";
/**
 * 代表管理
 */
const repreSentativeManage = {
  //代表分页
  getRepresentativeList(params) {
    return fetch({
      isLoading: true,
      url: "/representative/page",
      method: "GET",
      params,
    });
  },
  //删除代表白名单
  deleteRepresentative(data) {
    return fetch({
      isLoading: true,
      url: "/representative/delete",
      method: "POST",
      data,
    });
  },

  //失败数据导出
  exportRepresentativeFail(params) {
    return fetch({
      isLoading: true,
      url: "/representative/exportFail",
      method: "GET",
      params,
      responseType: "blob",
    });
  },
  // exportRepresentativeFail(params) {
  //   return fetch.get("/representative/exportData", {
  //     params,
  //     responseType: "blob",
  //   });
  // },
  //代表数据导出
  exportRepresentativeData(params) {
    return fetch({
      isLoading: true,
      url: "/representative/exportData",
      responseType: "blob",
      method: "GET",
      params,
    });
  },
  //修改代表白名单
  updateRepresentative(data) {
    return fetch({
      isLoading: true,
      url: "/representative/update",
      method: "POST",
      data,
    });
  },
  getRepresentativeConfig(params) {
    return fetch({
      isLoading: true,
      url: "/projectConfig/selectConfig",
      method: "GET",
      params,
    });
  },
  getrepresentativedeletes(params) {
    return fetch({
      isLoading: true,
      url: "/representative/deletes",
      method: "post",
      params,
    });
  },
};

export default repreSentativeManage;
